export default "__VITE_ASSET__CzB3UoNb__"